import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Theme,
  Container,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { FC } from "react";
import { NavLink } from "react-router-dom";
import { Auth } from "aws-amplify";
import { useAuthContext } from "../../core/auth-context";
import ProfileMenu from "./profile-menu";
import Overview from "./overview";
import NotificationMenu from "./notification-menu";
import JogSelectionModal from "./jog-selection-modal";
import NavMenu from "./nav-menu";
import NavButtons from "./nav-buttons";

const useStyles = makeStyles((theme: Theme) => ({
  navButton: {
    variant: "contained",
    color: "primary",
  },
  titleTab: {
    position: "relative",
    color: "white",
    textDecoration: "none",
    fontWeight: "bold",
  },
}));

const NavBar: FC = () => {
  const classes = useStyles();

  const { authState, setAuthState } = useAuthContext();

  async function handleLogout(): Promise<any> {
    try {
      await Auth.signOut();
      setAuthState({
        isAuthenticated: false,
        userGroups: [""],
        cognitoUsername: "",
        email: "",
      });
      window.open("/#/login", "_self");
    } catch (e) {
      // Review: Error handling
    }
  }

  return (
    <>
      <AppBar position="static">
        <Container maxWidth={false}>
          <Toolbar>
            <Button className={classes.navButton}>
              <NavLink className={classes.titleTab} to={"/dashboard"}>
                <Box pt={1}>
                  <Typography variant="h5">VCC</Typography>
                </Box>
              </NavLink>
            </Button>
            <Box
              sx={{
                flexGrow: 1,
                display: {
                  xs: "flex",
                  sm: "flex",
                  md: "flex",
                  lg: "flex",
                  xl: "none",
                },
              }}
            >
              <NavMenu />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "none",
                  xl: "flex",
                },
              }}
            >
              <NavButtons />
            </Box>
            <Box ml={2}>
              {authState.isAuthenticated &&
                <JogSelectionModal />
              }
            </Box>
            <Box ml={2}>
              {authState.isAuthenticated &&
                <NotificationMenu />
              }
            </Box>
            <Box ml={2}>
              <ProfileMenu
                props={{
                  isAuthenticated: authState.isAuthenticated,
                  handleLogout: handleLogout,
                }}
              />
            </Box>
            <Overview />
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};

export default NavBar;
